import { render, staticRenderFns } from "./listaPublicaciones.vue?vue&type=template&id=6ef496f7"
import script from "./listaPublicaciones.vue?vue&type=script&lang=js"
export * from "./listaPublicaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports